import type { Money } from "@amber/contracts";

export function amount(value: number): string {
  return value.toLocaleString("en-GB", {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

export function usd(m: Money | number): string {
  const value = typeof m === "number" ? m : Number(m.amount_decimal);
  return value > 0 && value < 0.005 ? "USD <0.01" : `USD ${amount(value)}`;
}

export const num = (m: Money) => Number(m.amount_decimal);
